<p-table
  class="block w-full h-full text-50"
  [value]="tableData"
  [columns]="tableColumns"
  [responsiveLayout]="'scroll'">
  <ng-template pTemplate="header" let-columns>
    @if (config?.widget?.table?.displayKeys && additionalHeaderRow.length) {
      <tr>
        <th class="font-normal" *ngFor="let col of additionalHeaderRow">
          <span>{{ col['header'] }}</span>
        </th>
      </tr>
    }

    <tr>
      <th *ngFor="let col of columns">
        {{ col.header }}
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr>
      <td *ngFor="let col of columns">
        {{ rowData[col.field] }}
      </td>
    </tr>
  </ng-template>
</p-table>
